import { ahuBoardApi } from 'app/services/ahuBoardApi';

/**
 * Phase 6e2b-1 — position-store HTTP endpoints (§51.3 / §20.6 #59-#61).
 * Injected into the shared ahuBoardApi (one reducerPath / baseQuery).
 *
 * Routes (api/rest_ahu/urls.py:592-618):
 *  - GET/PATCH  ahu/positions/<id>                 (generic — serves the
 *    on_cabinet REST shape when keyed by accessory id; §51.3)
 *  - GET/PUT/PATCH ahu/positions/on_cabinet/<id>   (PUT = create)
 *  - GET/PUT/PATCH ahu/positions/on_internal_walls/<id>
 */

export type PositionBase = '' | 'on_cabinet' | 'on_internal_walls';

const positionUrl = (base: PositionBase, id: number) =>
  `/api/v1.0/ahu/positions/${base ? `${base}/` : ''}${id}`;

export const accessoryFormsApi = ahuBoardApi.injectEndpoints({
  endpoints: (builder) => ({
    getPositionByBase: builder.query<
      Record<string, unknown>,
      { base: PositionBase; id: number }
    >({
      query: ({ base, id }) => positionUrl(base, id),
    }),
    patchPositionByBase: builder.mutation<
      Record<string, unknown>,
      { base: PositionBase; id: number; data: Record<string, unknown> }
    >({
      query: ({ base, id, data }) => ({
        url: positionUrl(base, id),
        method: 'PATCH',
        body: data,
      }),
    }),
    // createPosition (§49.6 / parity 332): legacy `fn.tools.save_model` =
    // Backbone save on a model WITH an id → PUT (route maps put→create).
    putPositionByBase: builder.mutation<
      Record<string, unknown>,
      { base: PositionBase; id: number; data: Record<string, unknown> }
    >({
      query: ({ base, id, data }) => ({
        url: positionUrl(base, id),
        method: 'PUT',
        body: { id, ...data },
      }),
    }),
  }),
  overrideExisting: false,
});
